import { Paper, Stack, Typography } from '@mui/material';
import { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import { ITime } from '../../interfaces/Types';
import { useAppSelector } from '../../store/hooks';
import { ReactComponent as TimesSvg } from '../../svg/times.svg';
import DayjsUtils from '../../utils/DayjsUtils';
import TimeUtils from '../../utils/TimeUtils';
import MonthPicker from '../common/MonthPicker';
import TimeEditPage from './TimeEditPage';
import TimeHistoryCard from './TimeHistoryCard';

const TimeHistoryPage = () => {
  const times = useAppSelector((state) => state.times.times);

  const [days, setDays] = useState<Dayjs[]>([]);
  const [historyTimes, setHistoryTimes] = useState<ITime[] | null>(null);
  const [workingTimeGlz, setWorkingTimeGlz] = useState<string | null>(null);
  const [availableTimeGlz, setAvailableTimeGlz] = useState<string | null>(null);

  // Date Range Picker callback function to set the selected date range
  const handleDateRangePicker = (dates: Dayjs[]) => setDays(dates);

  /*
  Simply sumup all working and available times reveived
  from Firestore DB and convert from a number to time string.
  */
  useEffect(() => {
    if (historyTimes) {
      let workingTimeSum = 0;
      let availableTimeSum = 0;
      historyTimes.forEach((time) => {
        workingTimeSum += time.workingTime;
        availableTimeSum += time.availableTime;
      });
      setWorkingTimeGlz(TimeUtils.minutesToTime(workingTimeSum));
      setAvailableTimeGlz(TimeUtils.minutesToTime(availableTimeSum));
    }
  }, [historyTimes]);

  /* 
  load all times from Firestore DB, either the select month,
  or the current month, if nothing selected yet.
  */
  useEffect(() => {
    const [from, to] = DayjsUtils.calculateFromAndTo(days);
    if (times && times.length > 0) {
      const filtered_times = TimeUtils.filterByTimestampRange(from.unix(), to.unix(), times);
      setHistoryTimes(filtered_times);
    }
  }, [days]);

  /*
    Open the time input page for the selected day.
  */
  const [showEdit, setShowEdit] = useState<boolean>(false);
  const [editDate, setEditDate] = useState<string>('');

  const handleEditClicked = (date: string) => {
    setEditDate(date);
    setShowEdit(true);
  };

  return (
    <>
      {showEdit ? (
        <TimeEditPage editDate={editDate} handleClose={() => setShowEdit(false)} />
      ) : (
        <Stack direction="column" alignItems="center" spacing={2}>
          <TimesSvg width="150px" height="150px" />
          <MonthPicker onChange={handleDateRangePicker} />
          {workingTimeGlz && availableTimeGlz && (
            <Paper elevation={1} sx={{ p: 2, width: '100%' }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body2">GLZ Saldo</Typography>
                <Typography variant="subtitle1">{workingTimeGlz} h</Typography>
                <Typography variant="body2">(Arbeitszeit)</Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body2">GLZ Saldo</Typography>
                <Typography variant="subtitle1">{availableTimeGlz} h</Typography>
                <Typography variant="body2">(Verfügungszeit)</Typography>
              </Stack>
            </Paper>
          )}
          {days && days.map((day) => <TimeHistoryCard key={day.toISOString()} day={day} handleEdit={handleEditClicked} />)}
        </Stack>
      )}
    </>
  );
};

export default TimeHistoryPage;
